/* =========================================================================
   SAMSARA — SECTION-HOME-CYCLE.JS
   Sprint 2 / T4 — Ciclul Samsara reveal.

   Logic:
     - IntersectionObserver pe .home-cycle__moment, threshold 0.2
     - Root margin -10% bottom (trigger ușor înainte de center)
     - Stagger via --cycle-delay-ms inline (index - 1) * 100ms
     - One-shot reveal (unobserve după prima activare)
     - Above-the-fold: dacă deja în viewport la boot, reveal imediat fără stagger
     - Reduced-motion safe (CSS handles disable; aici skip observer logic dacă matchMedia)
     - No-op dacă lipsește IntersectionObserver (graceful degrade — CSS fallback static via .is-revealed manual)

   Pattern: IIFE + 'use strict'.
   ========================================================================= */

(function () {
  'use strict';

  const STAGGER_MS = 100;
  const IO_THRESHOLD = 0.2;
  const IO_ROOT_MARGIN = '0px 0px -10% 0px';

  function boot() {
    const grid = document.querySelector('[data-cycle-grid]');
    if (!grid) return;

    const moments = grid.querySelectorAll('[data-cycle-moment]');
    if (!moments.length) return;

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;

    if (prefersReducedMotion) {
      // CSS handles visible state via @media (prefers-reduced-motion).
      // Marcăm .is-revealed pe toate ca să fie consistent dacă ulterior se
      // schimbă preferința runtime — o singură pasă, fără observer.
      moments.forEach(function (m) {
        m.classList.add('is-revealed');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      // Graceful degrade — fără observer, dezactivăm reveal complet (no flash).
      moments.forEach(function (m) {
        m.classList.add('is-revealed');
      });
      return;
    }

    function applyDelay(moment) {
      const idx = parseInt(moment.dataset.cycleIndex, 10) || 1;
      moment.style.setProperty('--cycle-delay-ms', ((idx - 1) * STAGGER_MS) + 'ms');
    }

    // Above-the-fold: blocks deja în viewport la boot → reveal imediat fără stagger.
    // Verificare rapidă cu getBoundingClientRect() înainte de attach observer.
    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    moments.forEach(function (m) {
      const rect = m.getBoundingClientRect();
      const inViewport = rect.top < viewportH * 0.9 && rect.bottom > 0;
      if (inViewport) {
        // Zero delay — evită glitch flicker pentru blocks vizibile la load.
        m.style.setProperty('--cycle-delay-ms', '0ms');
        // requestAnimationFrame ca să asigure transition pe state change
        window.requestAnimationFrame(function () {
          m.classList.add('is-revealed');
        });
      }
    });

    // Observer pentru blocks below-the-fold
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        const moment = entry.target;
        if (moment.classList.contains('is-revealed')) {
          observer.unobserve(moment);
          return;
        }
        applyDelay(moment);
        moment.classList.add('is-revealed');
        observer.unobserve(moment);
      });
    }, {
      threshold: IO_THRESHOLD,
      rootMargin: IO_ROOT_MARGIN,
    });

    moments.forEach(function (m) {
      if (!m.classList.contains('is-revealed')) {
        observer.observe(m);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();


/* =========================================================================
   Mobile carousel nav — prev/next + dots sync. Sprint 6 polish.
   ========================================================================= */
(function () {
  'use strict';

  function initNav(section) {
    const list = section.querySelector('[data-cycle-grid]');
    const prevBtn = section.querySelector('[data-cycle-prev]');
    const nextBtn = section.querySelector('[data-cycle-next]');
    const dots = section.querySelectorAll('[data-cycle-dot]');
    const items = section.querySelectorAll('[data-cycle-moment]');
    if (!list || !items.length) return;

    function getItemWidth() {
      const first = items[0];
      if (!first) return 0;
      const rect = first.getBoundingClientRect();
      const gap = parseFloat(getComputedStyle(list).gap) || 0;
      return rect.width + gap;
    }

    function getActiveIndex() {
      const w = getItemWidth();
      if (w === 0) return 0;
      return Math.round(list.scrollLeft / w);
    }

    function setActiveDot(index) {
      dots.forEach(function (d, i) {
        d.classList.toggle('home-cycle__dot--active', i === index);
      });
    }

    function scrollToIndex(index) {
      const clamped = Math.max(0, Math.min(index, items.length - 1));
      const w = getItemWidth();
      list.scrollTo({ left: w * clamped, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToIndex(getActiveIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToIndex(getActiveIndex() + 1); });

    let scrollTimer = null;
    list.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { setActiveDot(getActiveIndex()); }, 80);
    }, { passive: true });
  }

  function bootNavAll() {
    document.querySelectorAll('[data-home-cycle]').forEach(initNav);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootNavAll);
  } else {
    bootNavAll();
  }
})();
